module.exports = __webpack_public_path__ + "static/img/bank_on.239cef02.svg";